export const systemMenuList = [
    {
        "label": "Dashboard",
        "menuID": 1,
        "link": "/dashboard",
        "iconClass": "dashboard-icon",
        "children": []
    },
    {
        "label": "Account Details",
        "menuID": 2,
        "link": "/account-details",
        "iconClass": "dashboard-icon",
        "children": []
    },
    {
        "label": "Technical Details",
        "menuID": 3,
        "link": "/technical-details",
        "iconClass": "dashboard-icon",
        "children": []
    },

    {
        "label": "Client",
        "menuID": 640,
        "iconClass": "ph ph-users-three",//"client-icon",
        "children": [
            {
                "label": "SMS Client",
                "menuID": 533,
                "link": "/client/sms-client",
                "addMenuID": 534,
                "searchMenuID": 535,
            },
            {
                "label": "SMPP Profile",
                "menuID": 641,
                "link": "/client/smpp-profile",
                "addMenuID": 643,
                "searchMenuID": 644,
            },
            {

                "label": "HTTP Profile",
                "menuID": 642,
                "link": "/client/http-profile",
                "addMenuID": 646,
                "searchMenuID": 645,
            },
        ]
    },
    {
        "label": "Contact",
        "iconClass": "contact-icon",
        "menuID": 615,
        "children": [
            {
                "label": "SMS Contact",
                "menuID": 553,
                "link": "/contact/sms-contact",
                "addMenuID": 646,
                "searchMenuID": 645,
            }
        ]
    },
    {
        "label": "Text & Sender ID Management",
        "menuID": 630,
        "iconClass": "sender-icon",
        "children": [
            {
                "label": "Sender ID Inventory",
                "menuID": 700,
                "link": "/text-sender-id-management/sender-id-inventory",
            },
            {
                "label": "Sender ID Translation",
                "menuID": 582,
                "link": "/text-sender-id-management/sender-id-translation",
            },
            {
                "label": "Text Translation",
                "menuID": 579,
                "link": "/text-sender-id-management/text-translation",
            },
            {
                "label": "Content Whitelisting",
                "menuID": 574,
                "link": "/text-sender-id-management/content-whitelisting",
            },
            {
                "label": "Text & SenderID Blocking",
                "menuID": 585,
                "link": "/text-sender-id-management/content-blocking",
            }
        ]
    },
    {
        "label": "Rate and Destinations",
        "menuID": 650,
        "iconClass": "rate-icon",
        "children": [
            {
                "label": "My Rate",
                "menuID": 651,
                "link": "/rate-destination/my-rate",
            },
            {
                "label": "Rate Plan Format",
                "menuID": 550,
                "link": "/rate-destination/rate-plan-format",
            },
            {
                "label": "SMS Destination",
                "menuID": 544,
                "link": "/rate-destination/sms-destination",
            },
            {
                "label": "SMS Rate Plan",
                "menuID": 547,
                "link": "/rate-destination/sms-rate-plan",
            },
            {
                "label": "Ter Rate Import Settings",
                "menuID": 551,
                "link": "/rate-destination/ter-rate-import-settings",
            },
            {
                "label": "Manage LCR",
                "menuID": 661,
                "link": "/lcr-management/manage-lcr",
            },
            {
                "label": "Offer Rate",
                "menuID": 662,
                "link": "/lcr-management/offer-rate",
            }
        ]
    },

    {
        "label": "Bundle Management",
        "menuID": 1000,
        "iconClass": "bundle-icon",
        "children": [
            {
                "label": "SMS Bundles",
                "menuID": 1001,
                "link": "/bundle-management/sms-bundle",
            },
            {
                "label": "My Bundles",
                "menuID": 1021,
                "link": "/bundle-management/my-bundle",
            },
            {
                "label": "Bundle History",
                "menuID": 1011,
                "link": "/bundle-management/bundle-history"
            }
        ]
    },

    {
        "label": "Route Management",
        "menuID": 620,
        "iconClass": "route-icon",
        "children": [
            {
                "label": "SMS Route",
                "menuID": 536,
                "link": "/route-management/sms-route",
            },
            {
                "label": "SMS Translation",
                "menuID": 570,
                "link": "/route-management/sms-translation",
            },
            {
                "label": "Manage Response Code",
                "menuID": 625,
                "link": "/route-management/manage-response-code",
            }
        ]
    },

    {
        "label": "Campaign Management",
        "menuID": 610,
        "iconClass": "campaign-icon",
        "children": [

            {
                "label": "Quick SMS",
                "menuID": 1030,
                "link": "/campaign-management/quick-sms",
            },
            {
                "label": "SMS Campaign",
                "menuID": 556,
                "link": "/campaign-management/sms-campaign",
            },
            {
                "label": "Pending Requests",
                "menuID": 565,
                "link": "/campaign-management/pending-requests",
            },
            {
                "label": "Whatsapp Campaign",
                "menuID": 1234,
                "link": "/campaign-management/whatsapp-campaign",
            },
            {
                "label": "Whatsapp Campaign",
                "menuID": 1235,
                "link": "/campaign-management/whatsapp-campaign-login",
            }
        ]
    },
    {
        "index": 4,
        "label": "Financial & Accounts Report",
        "menuID": 53,
        "iconClass": "fn-report-icon",
        "children": [
            {
                "label": "Invoice Generation",
                "link": "/finance-and-accounts-report/invoice-generation",
                "menuID": 37,
            },
            {
                "label": "Invoice Log",
                "link": "/finance-and-accounts-report/invoice-log",
                "menuID": 124,
            },
            {
                "label": "Profit Summary",
                "link": "/finance-and-accounts-report/profit-summary",
                "menuID": 573,
            },
            {
                "label": "Bank Payment Approval( Upcoming )",
                "link": "/finance-and-accounts-report/bank-payment-approval",
                "menuID": 450,
            },
            {
                "label": "Recharge History",
                "link": "/finance-and-accounts-report/recharge-history",
                "menuID": 40,
            }
        ]
    },

    {
        "label": "General Reports",
        "menuID": 42,
        "iconClass": "op-report-icon",
        "children": [
            {
                "label": "Contact Report",
                "link": "/general-reports/sms-contact-report",
                "menuID": 600,
            },
            {
                "label": "Campaign Report",
                "link": "/general-reports/sms-campaign-report",
                "menuID": 601,
            },
            {
                "label": "SMS History",
                "link": "/general-reports/sms-history-report",
                "menuID": 539,

            },
            {
                "label": "RCS History",
                "link": "/general-reports/rcs-history-report",
                "menuID": 612,

            },
            {
                "label": "Sigtran History",
                "link": "/sigtran/history-report",
                "menuID": 612,

            },
            {
                "label": "Sigtran Retry History",
                "link": "/sigtran/retry-history-report",
                "menuID": 612,

            },
            {
                "label": "Performance Report",
                "link": "/general-reports/performance-report",
                "menuID": 900,

            },
            {
                "label": "General Activity Log",
                "link": "/general-reports/general-activity-log",
                "menuID": 121,

            },
            {
                "label": "Alarm History",
                "link": "/general-reports/alarm-history-report",
                "menuID": 492,

            },

        ]
    },
    {
        "label": "Live Report",
        "menuID": 603,
        "iconClass": "live-report-icon",
        "children": [
            {
                "label": "Live SMS Status",
                "link": "/live-reports/live-sms-status-report",
                "menuID": 604,

            },
            {
                "label": "SMS Queue",
                "link": "/live-reports/sms-queue-log",
                "menuID": 605,

            },
            {
                "label": "Pending SMS Approval",
                "link": "/live-reports/pending-sms-approval",
                "menuID": 577,

            },

        ]
    },

    {
        "label": "Analytics",
        "menuID": 800,
        "iconClass": "analytics-icon",
        "children": [
            {
                "label": "Performance Analytics",
                "link": "/analytics/performance-analytics",
                "menuID": 801,

            },
            {
                "label": "Revenue Analytics",
                "link": "/analytics/revenue-analytics",
                "menuID": 802,

            },
        ]
    },

    {
        "label": "MO SMS",
        "menuID": 1100,
        "iconClass": "mo-sms-icon",
        "children": [
            {
                "label": "SMS Inbox",
                "link": "/mo-sms/sms-inbox",
                "menuID": 1101,

            },
        ]
    },

    {
        "label": "Users",
        "menuID": 21,
        "iconClass": "user-icon",
        "children": [
            {
                "label": "Manage Users",
                "link": "/users/manage-users",
                "menuID": 22,

            },
            {
                "label": "Manage Account Manager",
                "link": "/users/manage-account-manager",
                "menuID": 529,
                "addMenuID": 530,
                "searchMenuID": 531,
            },
            {
                "label": "Manage Roles",
                "link": "/users/manage-roles",
                "menuID": 25,

            },

        ]
    },

    {
        "label": "Settings",
        "menuID": 606,
        "iconClass": "settings-icon",
        "children": [
            {
                "label": "System Configuration",
                "menuID": 104,
                "link": "/settings/system-config",

            },
            {
                "label": "System Currency",
                "link": "/settings/manage-currency",
                "menuID": 106,

            },
            {
                "label": "Mail Server Information",
                "link": "/settings/mail-server-information",
                "menuID": 175,

            },
            {
                "label": "Invoice Configuration",
                "link": "/settings/invoice-configuration",
                "menuID": 200,
            },
            {
                "label": "MNP Configuration",
                "menuID": 901,
                "link": "/settings/sms-dipping",

            },
            {
                "label": "HLR Lookup Configuration",
                "menuID": 902,
                "link": "/settings/sms-hlr-lookup",
            },
            {
                "label": "Payment Gateway",
                "link": "/settings/payment-gateway",
                "menuID": 199,

            },
            {
                "label": "System Alert",
                "link": "/settings/system-alert",
                "menuID": 163,

            },


        ]
    },
    {
        "label": "Security",
        "menuID": 350,
        "iconClass": "security-icon",
        "children": [
            {
                "label": "Restricted IPs",
                "link": "/security/black-or-white-list-ips/",
                "menuID": 351,

            },
            {
                "label": "UnAuthorize Access Log",
                "menuID": 353,
                "link": "/security/un-auth-access-params",

            },
            {
                "label": "Active Login",
                "link": "/security/active-login",
                "menuID": 607,

            },
            {
                "label": "Payment Security",
                "link": "/security/payment-security",
                "menuID": 588,

            },
        ]
    },
]


export const systemMenuList2 = [
    {
        label: "Dashboard",
        menuID: 1,
        iconClass: "dashboard-icon",
        expand: false,
        children: [
            {
                "label": "Dashboard",
                "menuID": 1,
                "iconClass": "dashboard-icon",
                "link": "/dashboard",
                children: []
            }
        ],

    },
    {
        label: "Account Details",
        menuID: 2,
        iconClass: "ph ph-identification-card",
        expand: false,
        children: [
            {
                "label": "Account Details",
                "menuID": 2,
                "link": "/account-details",
                "iconClass": "ph ph-user",
                "children": []
            }
        ],
    },
    {
        "label": "Technical Details",
        "menuID": 3,
        expand: false,
        children: [
            {
                "label": "Technical Details",
                "menuID": 3,
                "link": "/technical-details",
                "children": []
            }
        ],
    },

    {
        "label": "Client",
        "menuID": 640,
        children: [
            {
                "label": "Client",
                "menuID": 640,
                "children": [
                    {
                        "label": "SMS Client",
                        "menuID": 533,
                        "link": "/client/sms-client",
                        "addMenuID": 534,
                        "searchMenuID": 535,
                    },
                    {
                        "label": "SMPP Profile",
                        "menuID": 641,
                        "link": "/client/smpp-profile",
                        "addMenuID": 643,
                        "searchMenuID": 644,
                    },
                    {

                        "label": "HTTP Profile",
                        "menuID": 642,
                        "link": "/client/http-profile",
                        "addMenuID": 646,
                        "searchMenuID": 645,
                    },
                    {
                        "label": "RCS Profile",
                        "menuID": 611,
                        "link": "/client/rcs-profile",
                    },

                ]
            }
        ]
    },
    {
        "label": "Contact",
        "menuID": 615,
        children: [
            {
                "label": "Contact",
                "menuID": 615,
                children: [
                    {
                        "label": "SMS Contact",
                        "menuID": 553,
                        "link": "/contact/sms-contact",
                        "addMenuID": 646,
                        "searchMenuID": 645,
                    }
                ]
            }
        ],
    },
    {
        "label": "Text & Sender ID",
        "menuID": 630,
        children: [
            {
                "label": "Text & Sender ID",
                "menuID": 630,
                "children": [
                    {
                        "label": "Sender ID Inventory",
                        "menuID": 700,
                        "link": "/text-sender-id-management/sender-id-inventory",
                    },
                    {
                        "label": "Sender ID Translation",
                        "menuID": 582,
                        "link": "/text-sender-id-management/sender-id-translation",
                    },
                    {
                        "label": "Text Translation",
                        "menuID": 579,
                        "link": "/text-sender-id-management/text-translation",
                    },
                    {
                        "label": "Content Whitelisting",
                        "menuID": 574,
                        "link": "/text-sender-id-management/content-whitelisting",
                    },
                    {
                        "label": "Text & SenderID Blocking",
                        "menuID": 585,
                        "link": "/text-sender-id-management/content-blocking",
                    }
                ]
            }
        ]
    },

    {
        label: "Rate and Destinations",
        menuID: 650,
        children: [
            {
                "label": "Rate and Destinations",
                "menuID": 650,
                "children": [
                    {
                        "label": "Rate Plan Format",
                        "menuID": 550,
                        "link": "/rate-destination/rate-plan-format",
                    },
                    {
                        "label": "SMS Destination",
                        "menuID": 544,
                        "link": "/rate-destination/sms-destination",
                    },
                    {
                        "label": "SMS Rate Plan",
                        "menuID": 547,
                        "link": "/rate-destination/sms-rate-plan",
                    },
                    {
                        "label": "Ter Rate Import Settings",
                        "menuID": 551,
                        "link": "/rate-destination/ter-rate-import-settings",
                    },
                    {
                        "label": "My Rate",
                        "menuID": 651,
                        "link": "/rate-destination/my-rate",
                    },
                ]
            },
            {
                "label": "LCR Management",
                "menuID": 660,
                "children": [
                    {
                        "label": "Manage LCR",
                        "menuID": 661,
                        "link": "/lcr-management/manage-lcr",
                    },
                    {
                        "label": "Offer Rate",
                        "menuID": 662,
                        "link": "/lcr-management/offer-rate",
                    }
                ]
            },
        ]
    },


    {
        label: "Bundle Management",
        menuID: 1000,
        children: [
            {
                "label": "Bundle Management",
                "menuID": 1000,
                "children": [
                    {
                        "label": "SMS Bundles",
                        "menuID": 1001,
                        "link": "/bundle-management/sms-bundle",
                    },
                    {
                        "label": "My Bundles",
                        "menuID": 1021,
                        "link": "/bundle-management/my-bundle",
                    },
                    {
                        "label": "Bundle History",
                        "menuID": 1011,
                        "link": "/bundle-management/bundle-history"
                    }
                ]
            },
        ]
    },


    {
        label: "Route Management",
        menuID: 620,
        children: [
            {
                "label": "Route Management",
                "menuID": 620,
                "children": [
                    {
                        "label": "SMS Route",
                        "menuID": 536,
                        "link": "/route-management/sms-route",
                    },
                    {
                        "label": "SMS Translation",
                        "menuID": 570,
                        "link": "/route-management/sms-translation",
                    },
                    {
                        "label": "Manage Response Code",
                        "menuID": 625,
                        "link": "/route-management/manage-response-code",
                    },
                ]
            }
        ]
    },

    {
        label: "Sigtran",
        menuID: 750,
        iconClass: "ph ph-broadcast",
        // No `expand` key on purpose. menuItemClicked() defaults to true when it
        // is absent; setting it false (as Dashboard does) permanently collapses
        // the flyout, which is right for a single-leaf menu but wrong here -
        // Sigtran has three groups the user needs to reach.
        children: [
            {
                // Labels at this level sit directly under the "Sigtran" module header, so
                // they carry no "Sigtran" prefix - the same reason the Reports group below
                // is not "Sigtran Reports". The leaf pages keep their full names.
                //
                // A plain link, not a group: this was a group of ONE page, which drew a
                // caret and cost a second click to reach a single destination. An empty
                // children array is the shape the sidebar already handles - the template
                // conditions active-parent-link on it, and getActivatedMenuIDs matches a
                // level-2 link before it descends. menuID is the PAGE (754), which is
                // also what the page's own permission guard checks; the old group row 751
                // is gone from vbMenu too.
                "label": "Dashboard",
                "menuID": 754,
                "iconClass": "ph ph-gauge",
                "link": "/sigtran/dashboard",
                "children": []
            },
            {
                "label": "Configuration",
                "menuID": 752,
                "iconClass": "ph ph-sliders",
                "children": [
                    {
                        "label": "Sigtran Configuration",
                        "link": "/sigtran/configuration",
                        "menuID": 710,
                    },
                    {
                        "label": "Sigtran Profile",
                        "link": "/sigtran/profile",
                        "menuID": 757,
                    },
                    {
                        "label": "MO Route",
                        "link": "/sigtran/mo-route",
                        "menuID": 758,
                    },
                ]
            },
            {
                "label": "Reports",
                "menuID": 753,
                "iconClass": "ph ph-file-text",
                "children": [
                    {
                        "label": "Sigtran History",
                        "link": "/sigtran/history-report",
                        "menuID": 740,
                    },
                    {
                        "label": "Sigtran Retry History",
                        "link": "/sigtran/retry-history-report",
                        "menuID": 745,
                    },
                    {
                        "label": "SenderID wise Summary",
                        "link": "/sigtran/senderid-wise-summary-report",
                        "menuID": 755,
                    },
                    {
                        "label": "Destination wise Summary",
                        "link": "/sigtran/destination-wise-summary-report",
                        "menuID": 756,
                    },
                    {
                        "label": "Sigtran MO Inbox",
                        "link": "/sigtran/mo-inbox",
                        "menuID": 759,
                    },
                ]
            },
        ],
    },

    {
        "label": "Campaign",
        "menuID": 610,
        children: [
            {
                "label": "Campaign Management",
                "menuID": 610,
                "children": [
                    {
                        "label": "Quick SMS",
                        "menuID": 1030,
                        "link": "/campaign-management/quick-sms",
                    },
                    {
                        "label": "SMS Campaign",
                        "menuID": 556,
                        "link": "/campaign-management/sms-campaign",
                    },
                    {
                        "label": "Pending Requests",
                        "menuID": 565,
                        "link": "/campaign-management/pending-requests",
                    },
                    {
                        "label": "Whatsapp Campaign Login",
                        "menuID": 649,
                        "link": "/campaign-management/whatsapp-campaign-login",
                    }
                ]
            }
        ]

    },

    {
        "label": "Reports",
        "menuID": 42,
        children: [
            {
                "label": "General Reports",
                "menuID": 42,
                "children": [
                    {
                        "label": "Contact Report",
                        "link": "/general-reports/sms-contact-report",
                        "menuID": 600,
                    },
                    {
                        "label": "Campaign Report",
                        "link": "/general-reports/sms-campaign-report",
                        "menuID": 601,
                    },
                    {
                        "label": "SMS History",
                        "link": "/general-reports/sms-history-report",
                        "menuID": 539,

                    },
                    {
                        "label": "RCS History",
                        "link": "/general-reports/rcs-history-report",
                        "menuID": 612,

                    },
                    {
                        "label": "Performance Report",
                        "link": "/general-reports/performance-report",
                        "menuID": 900,

                    },
                    {
                        "label": "General Activity Log",
                        "link": "/general-reports/general-activity-log",
                        "menuID": 121,

                    },
                    {
                        "label": "Alarm History",
                        "link": "/general-reports/alarm-history-report",
                        "menuID": 492,

                    },
                    {
                        "label": "Rejected Requests",
                        "link": "/general-reports/rejected-requests",
                        "menuID": 1201,
                    },

                ]
            },
            {
                "index": 4,
                "label": "Financial & Accounts",
                "menuID": 53,
                "iconClass": "ph ph-receipt",
                "children": [
                    {
                        "label": "Invoice Log",
                        "link": "/finance-and-accounts-report/invoice-log",
                        "menuID": 124,
                    },
                    {
                        "label": "Profit Summary ",
                        "link": "/finance-and-accounts-report/profit-summary",
                        "menuID": 573,
                    },
                    {
                        "label": "Bank Payment Approval",
                        "link": "/finance-and-accounts-report/bank-payment-approval",
                        "menuID": 450,
                    },
                    {
                        "label": "Recharge History",
                        "link": "/finance-and-accounts-report/recharge-history",
                        "menuID": 40,
                    },
                    {
                        "label": "NetOff",
                        "link": "/finance-and-accounts-report/net-off",
                        "menuID": 55,
                    }
                ]
            },
            {
                "label": "Live Report",
                "menuID": 603,
                "iconClass": "ph ph-chart-pie-slice",
                "children": [
                    {
                        "label": "Live SMS Status",
                        "link": "/live-reports/live-sms-status-report",
                        "menuID": 604,

                    },
                    {
                        "label": "SMS Queue",
                        "link": "/live-reports/sms-queue-log",
                        "menuID": 605,

                    },
                    {
                        "label": "Pending SMS Approval",
                        "link": "/live-reports/pending-sms-approval",
                        "menuID": 577,

                    },

                ]
            },
            {
                "label": "Analytics",
                "menuID": 800,
                "iconClass": "ph ph-chart-line-up",
                "children": [
                    {
                        "label": "Performance Analytics",
                        "link": "/analytics/performance-analytics",
                        "menuID": 801,

                    },
                    {
                        "label": "Revenue Analytics",
                        "link": "/analytics/revenue-analytics",
                        "menuID": 802,

                    },
                ]
            },
            {
                "label": "MO SMS",
                "menuID": 1100,
                "iconClass": "ph ph-envelope-open",
                "children": [
                    {
                        "label": "SMS Inbox",
                        "link": "/mo-sms/sms-inbox",
                        "menuID": 1101,

                    },
                ]
            },
        ],
    },

    {
        "label": "Users",
        "menuID": 21,
        children: [
            {
                "label": "Users",
                "menuID": 21,
                "children": [
                    {
                        "label": "Manage Users",
                        "link": "/users/manage-users",
                        "menuID": 22,

                    },
                    {
                        "label": "Manage Account Manager",
                        "link": "/users/manage-account-manager",
                        "menuID": 529,
                        "addMenuID": 530,
                        "searchMenuID": 531,
                    },
                    {
                        "label": "Manage Roles",
                        "link": "/users/manage-roles",
                        "menuID": 25,

                    },

                ]
            }
        ]

    },
    {
        "label": "Settings & Security",
        "menuID": 606,
        children: [
            {
                "label": "Settings",
                "menuID": 606,
                "children": [
                    {
                        "label": "System Configuration",
                        "menuID": 104,
                        "link": "/settings/system-config",

                    },
                    {
                        "label": "System Currency",
                        "link": "/settings/manage-currency",
                        "menuID": 106,

                    },
                    {
                        "label": "Mail Server Information",
                        "link": "/settings/mail-server-information",
                        "menuID": 175,

                    },
                    {
                        "label": "Invoice Configuration",
                        "link": "/settings/invoice-configuration",
                        "menuID": 200,

                    },
                    {
                        "label": "MNP Configuration",
                        "menuID": 901,
                        "link": "/settings/sms-dipping",

                    },
                    {
                        "label": "HLR Lookup Configuration",
                        "menuID": 902,
                        "link": "/settings/sms-hlr-lookup",
                    },
                    {
                        "label": "My Bank Info",
                        "link": "/settings/bank-info",
                        "menuID": 198,
                    },
                    {
                        "label": "Payment Gateway",
                        "link": "/settings/payment-gateway",
                        "menuID": 199,

                    },
                    {
                        "label": "System Alert",
                        "link": "/settings/system-alert",
                        "menuID": 163,

                    },
                    {
                        "label": "Notice Configuration",
                        "link": "/settings/notice-configuration",
                        "menuID": 165,

                    }
                ]
            },

            {
                "label": "Security",
                "menuID": 350,
                "iconClass": "ph ph-lock-key",
                "children": [
                    {
                        "label": "Restricted IPs",
                        "link": "/security/black-or-white-list-ips/",
                        "menuID": 351,

                    },
                    {
                        "label": "UnAuthorize Access Log",
                        "menuID": 353,
                        "link": "/security/un-auth-access-params",

                    },
                    {
                        "label": "Active Login",
                        "link": "/security/active-login",
                        "menuID": 607,

                    },
                    {
                        "label": "Payment Security",
                        "link": "/security/payment-security",
                        "menuID": 588,

                    },
                ]
            },
        ]

    },

    // {
    //     "label": "Security",
    //     "menuID": 350,
    //     "iconClass": "ph ph-lock-key",//"security-icon",
    //     children:[
    //         {
    //             "label": "Security",
    //             "menuID": 350,
    //             "iconClass": "ph ph-lock-key",
    //             "children": [
    //                 {
    //                     "label": "Restricted IPs",
    //                     "link": "/security/black-or-white-list-ips/",
    //                     "menuID": 351,
    //
    //                 },
    //                 {
    //                     "label": "UnAuthorize Access Log",
    //                     "menuID": 353,
    //                     "link": "/security/un-auth-access-params",
    //
    //                 },
    //                 {
    //                     "label": "Active Login",
    //                     "link": "/security/active-login",
    //                     "menuID": 607,
    //
    //                 },
    //                 {
    //                     "label": "Payment Security",
    //                     "link": "/security/payment-security",
    //                     "menuID": 588,
    //
    //                 },
    //             ]
    //         }
    //     ]
    //
    // }
]


export const PermissionConstants = {
    "PERMISSION_READ": 1,
    "PERMISSION_MODIFY": 2,
    "PERMISSION_FULL": 3,

    // The dashboard menu. The node has always existed in systemMenuList2, but there was
    // no vbMenu row and no grant until v5.3.5.19 - the page was reachable only because
    // "/" redirected straight to it.
    "DASHBOARD": 1,


    "USERS": 21, //parent menu
    "MANAGE_USERS": 22,
    "MANAGE_USERS_ADD": 23,
    "MANAGE_USERS_SEARCH": 24,

    "MANAGE_ACCOUNT_MANAGER": 529,
    "MANAGE_ACCOUNT_MANAGER_ADD": 530,
    "MANAGE_ACCOUNT_MANAGER_SEARCH": 531,

    "MANAGE_ROLES": 25,
    //"MANAGE_ROLES_ADD": 26,
    //"MANAGE_ROLES_SEARCH": 27,

    "MANAGE_LANGUAGE": 77,
    "MANAGE_LANGUAGE_ADD_LANGUAGE": 78,
    "MANAGE_LANGUAGE_SEARCH": 79,
    "ACCOUNTS": 35,
    "MANAGE_ACCOUNTS": 36,
    "MANAGE_ACCOUNTS_BILL_GENERATION": 37,
    "MANAGE_ACCOUNTS_VIEW_PAYMENT": 40,
    "MANAGE_SYSTEM_CONFIGURATION": 104,
    "MANAGE_SYSTEM_CURRENCY": 106,
    "MANAGE_INVOICE_CONFIGURATION": 200,
    "PROVIDER_MANAGEMENT": 640,
    "MANAGE_SMS_PROVIDER": 533,
    "MANAGE_SMS_PROVIDER_ADD": 534,
    "MANAGE_SMS_PROVIDER_SEARCH": 535,
    "MANAGE_SMPP_PROFILE": 641,
    "MANAGE_SMPP_PROFILE_ADD": 644,
    "MANAGE_SMPP_PROFILE_SEARCH": 643,
    "MANAGE_HTTP_PROFILE": 642,
    "MANAGE_HTTP_PROFILE_ADD": 646,
    "MANAGE_HTTP_PROFILE_SEARCH": 645,
    "MANAGE_RCS_PROFILE": 611,

    //SMS Country Module
    "MANAGE_SMS_COUNTRY": 544,
    "MANAGE_SMS_COUNTRY_ADD": 545,
    "MANAGE_SMS_COUNTRY_SEARCH": 546,


    // General Reports
    "GENERAL_REPORTS": 42,
    'ALARM_HISTORY_REPORT': 492,
    'GENERAL_ACTIVITY_LOG': 121,
    'SMS_HISTORY_REPORT': 539,
    'RCS_HISTORY_REPORT': 612,
    "CONTACT_REPORT": 600,
    "CAMPAIGN_REPORT": 601,
    "LIVE_REPORT": 603,
    "LIVE_SMS_STATUS": 604,
    "SMS_QUEUE": 605,
    "CONTENT_APPROVAL": 577,
    "REJECTED_REQUESTS": 1201,

    //Settings

    "SETTINGS": 606,
    "ACTIVE_LOGIN": 607,
    "CAMPAIGN_MANAGEMENT": 610,
    "CONTACT": 615,
    "BANK_INFO": 198,

    // Route Management Module

    "ROUTE_MANAGEMENT": 620,
    'SMS_ROUTE': 536,
    'SMS_ROUTE_ADD': 537,
    'SMS_ROUTE_SEARCH': 538,
    "MANAGE_RESPONSE_CODE": 625,
    "RESPONSE_CODE_SEARCH": 626,
    "RESPONSE_CODE_ADD": 627,
    "SIGTRAN": 750,
    "SIGTRAN_CONFIGURATION_SECTION": 752,
    "SIGTRAN_REPORTS_SECTION": 753,
    "SIGTRAN_DASHBOARD": 754,
    "SIGTRAN_CONFIGURATION": 710,
    "SIGTRAN_PROFILE": 757,
    "SIGTRAN_MO_ROUTE": 758,
    "SIGTRAN_CONFIGUTATION": 710, // deprecated misspelling, kept as an alias; remove once all call sites use SIGTRAN_CONFIGURATION

    // TEXT AND SENDER ID MANAGEMENT

    "TEXT_AND_SENDER_ID_MANAGEMENT": 630,
    "SENDER_ID_INVENTORY": 700,
    "SENDER_ID_INVENTORY_ADD": 702,
    //"SENDER_ID_INVENTORY_SEARCH": 701,

    //Rate Management
    "RATE_AND_DESTINATION": 650,
    "RATE_PLAN_FORMAT": 550,
    "RATE_PLAN_FORMAT_ADD": 452,
    "RATE_PLAN_FORMAT_SEARCH": 453,
    "MANAGE_MY_RATE": 651,


    "TER_RATE_IMPORT_SETTINGS": 551,

    "MANAGE_SMS_RATEPLAN": 547,
    "MANAGE_SMS_RATEPLAN_ADD": 548,
    "MANAGE_SMS_RATEPLAN_SEARCH": 549,

    //LCR Management
    "LCR_MANAGEMENT": 660,
    "MANAGE_LCR": 661,
    "OFFER_RATE": 662,
    //Rate Management

    "ANALYTICS": 800,
    "PERFORMANCE_ANALYTICS": 801,
    "REVENUE_ANALYTICS": 802,
    "PERFORMANCE_REPORT": 900,
    "SIGTRAN_REPORT": 740,
    "SIGTRAN_RETRY_REPORT": 745,
    "SIGTRAN_SENDERID_SUMMARY_REPORT": 755,
    "SIGTRAN_DESTINATION_SUMMARY_REPORT": 756,
    "SIGTRAN_MO_INBOX": 759,
    "QUICK_SMS": 1030,
    "BUNDLE_MANAGEMENT": 1000,
    "SMS_BUNDLE": 1001,
    "SMS_BUNDLE_ADD": 1002,
    "SMS_BUNDLE_SEARCH": 1003,

    "BUNDLE_HISTORY": 1011,
    "MY_SMS_BUNDLE": 1021,

    "SENDERID_TRANSLATION": 582,
    "SENDERID_TRANSLATION_ADD": 583,
    "SENDERID_TRANSLATION_SEARCH": 584,


    //Content Translation
    "CONTENT_TRANSLATION": 579,
    "CONTENT_TRANSLATION_ADD": 580,
    "CONTENT_TRANSLATION_SEARCH": 581,

    // Content White List
    "CONTENT_WHITELIST": 574,
    "CONTENT_WHITELIST_ADD": 575,
    "CONTENT_WHITELIST_SEARCH": 576,

    //Content Blocking
    "CONTENT_BLOCK": 585,
    "CONTENT_BLOCK_ADD": 586,
    "CONTENT_BLOCK_SEARCH": 587,

    //Finance

    'REPORTS_FINANCE': 53,
    'INVOICE_LOG': 124,
    'INVOICE_GENERATION': 37,
    "SMS_PROFIT_SUMMARY": 573,
    "BANK_APPROVAL": 450,
    "NET_OFF": 55,


    ///SMS Translation
    "SMS_TRANSLATION": 570,
    "SMS_TRANSLATION_ADD": 571,
    "SMS_TRANSLATION_SEARCH": 572,


    ////SMS Campaign
    "MANAGE_SMS_CAMPAIGN": 556,
    "MANAGE_SMS_CAMPAIGN_ADD": 557,
    "MANAGE_SMS_CAMPAIGN_SEARCH": 558,
    "SMS_PENDING_REQUEST": 565,
    "WHATSAPP_CAMPAIGN_LOGIN": 649,

    // MO SMS

    "MO_SMS": 1100,
    "SMS_INBOX": 1101,


    //Security
    "MANAGE_SECURITY": 350,
    "MANAGE_IP_RESTRICTION": 351,
    "UNAUTHORIZED_ACTIVITY_LOG": 353,
    "PAYMENT_SECURITY": 588,
    "PAYMENT_SECURITY_ADD": 589,
    "PAYMENT_SECURITY_SEARCH": 590,


    ///MailServer
    "MANAGE_MAILSERVER_INFORMATION": 175,
    "SYSTEM_ALERT": 163,
    "NOTICE_CONFIGURATION": 165,


    ///SMS Contact
    "SMS_CONTACT": 553,
    "SMS_CONTACT_ADD": 554,
    "SMS_CONTACT_SEARCH": 555,


    ///Settings
    "SMS_DIPPING": 901,
    "SMS_DIPPING_ADD": 568,
    "SMS_DIPPING_SEARCH": 569,
    "PAYMENT_GATEWAY": 199,
    "HLR_LOOKUP_CONFIGURATION": 902,

    //Account Details

    'ACCOUNT_DETAILS': 2,
    'TECHNICAL_DETAILS': 3

}


export function getActivatedMenuIDsOld(curLink) {
    let activeParentMenuID = 1;
    let activeSubMenuID = 1;
    console.log("Path is: ", curLink);
    for (const menu of systemMenuList) {
        console.log(menu);
        if (menu["link"] && (curLink.includes(menu["link"]) || menu["link"].includes(curLink))) {
            activeParentMenuID = (menu.menuID ? menu.menuID : 1);
        }

        if (menu.children) {
            for (const child of menu.children) {
                if (child["link"] && (curLink.includes(child["link"]) || child["link"].includes(curLink))) {
                    activeParentMenuID = (menu.menuID ? menu.menuID : 1);
                    activeSubMenuID = (child.menuID ? child.menuID : 1);
                }
            }
        }
    }
    return {activeParentMenuID, activeSubMenuID};
}

/**
 * Does the current URL belong to this menu link?
 *
 * Previously this was a bare substring test in both directions, which matches
 * across path boundaries: "/dashboard" tested against "/sigtran/dashboard"
 * succeeded, so opening the main dashboard also lit up the Sigtran menu (and,
 * because Sigtran appears later in the array and last match wins, kept the
 * flyout open). Boundaries are now respected.
 */
function linkMatches(curLink, link) {
    if (!curLink || !link) return false;
    if (curLink === link) return true;
    // sub-path: /sigtran/configuration/5 belongs to /sigtran/configuration
    if (curLink.startsWith(link + '/')) return true;
    // sibling detail page: /sigtran/configuration-edit/5 belongs to /sigtran/configuration
    if (curLink.startsWith(link + '-')) return true;
    // the old lenient reverse direction, but only on a path boundary
    if (link.startsWith(curLink + '/')) return true;
    return false;
}

/**
 * Reduce a URL to the bare path menu links are written as.
 *
 * Callers pass whatever they have: route.path (already clean) or the hash fragment
 * of window.location.href, which carries the query string with it. SSO login lands
 * on "/sigtran/dashboard?fromLogin=true", and with the query still attached nothing
 * matched - the sidebar came up with no menu selected and its expand toggle inert,
 * because expandedMenuObj was never populated.
 */
function pathOf(curLink) {
    if (!curLink) return curLink;
    return curLink.split('?')[0].split('#')[0];
}

export function getActivatedMenuIDs(rawLink) {
    const curLink = pathOf(rawLink);
    let activeTopMenuObj = {};
    let activeParentMenuObj = {};
    let activeSubMenuObj = {};
    //console.log("Path is: ", curLink);
    for (const menu of systemMenuList2) {
        //console.log(menu);

        if (menu.children) {
            for (const childLevel2 of menu.children) {
                if (linkMatches(curLink, childLevel2["link"])) {
                    activeParentMenuObj = childLevel2;
                    activeTopMenuObj = menu;
                }

                if (childLevel2.children) {
                    for (const childLevel3 of childLevel2.children) {
                        if (linkMatches(curLink, childLevel3["link"])) {
                            activeSubMenuObj = childLevel3;
                            activeParentMenuObj = childLevel2;
                            activeTopMenuObj = menu;
                        }
                    }
                }
            }
        }
    }
    return {activeTopMenuObj, activeParentMenuObj, activeSubMenuObj};
}







/* ------------------------------------------------------------------ landing page */

/** Hidden from the rail by SideBar.vue, so it is a poor place to land someone. */
const LANDING_DEPRIORITISED_MENU_IDS = [2];

/**
 * Permission level for a menu, read straight from localStorage.
 *
 * Deliberately not the Vuex getter: this runs inside a vue-router redirect, which is
 * not a component setup context, so useStore() is unavailable. util.js already has the
 * same fallback pattern in checkPermissionIfStoreNotInitialized().
 */
function menuPermissionLevel(userDetails, menuID) {
    if (!userDetails || !userDetails.menuPermission) return 0;
    const level = userDetails.menuPermission[menuID];
    return level == null ? 0 : parseInt(level);
}

/** First leaf link under a level-one node that the user can actually open. */
function firstPermittedLinkUnder(topMenu, userDetails) {
    if (!topMenu || !Array.isArray(topMenu.children)) return null;

    for (const levelTwo of topMenu.children) {
        if (!levelTwo || menuPermissionLevel(userDetails, levelTwo.menuID) < 1) continue;

        // A level-two node with no children carries the link itself - that is the shape
        // the Dashboard uses (menuID 1 at both levels, link /dashboard).
        if (!Array.isArray(levelTwo.children) || levelTwo.children.length === 0) {
            if (levelTwo.link) return levelTwo.link;
            continue;
        }

        for (const levelThree of levelTwo.children) {
            if (!levelThree || !levelThree.link) continue;
            if (menuPermissionLevel(userDetails, levelThree.menuID) >= 1) return levelThree.link;
        }
    }
    return null;
}

/**
 * Where "/" should send this user.
 *
 * Until v5.3.5.19 the router hard-redirected "/" to /dashboard, which is fine while
 * every customer owns the SMS module and useless once Sigtran is sold on its own - a
 * Sigtran-only user would land on a page they cannot open before clicking anything.
 *
 * Walks systemMenuList2 in display order and returns the first page the role actually
 * holds, so the rail brand logo (which links to "/") keeps working for every customer
 * without naming any module.
 *
 * Falls back to /dashboard rather than /forbidden when permissions are missing. On a
 * cold reload the redirect can resolve before login state is readable, and bouncing a
 * legitimate user to /forbidden is far worse than showing them the page they would
 * have got before this change.
 */
export function firstPermittedRoute() {
    let userDetails = null;
    try {
        userDetails = JSON.parse(localStorage.getItem("userDetails"));
    } catch (e) {
        console.warn("Could not read userDetails for landing redirect", e);
    }

    // An absent OR empty map means login state is not readable yet. On a cold reload the
    // redirect can resolve before it is hydrated, and bouncing a legitimate user to
    // /forbidden is worse than showing them what they saw before this change. A user who
    // genuinely holds nothing still gets stopped, by the page guard rather than here.
    if (!userDetails || !userDetails.menuPermission
        || Object.keys(userDetails.menuPermission).length === 0) {
        return "/dashboard";
    }

    const landing = resolveLanding(userDetails);
    if (landing) return landing.link;

    console.warn("No permitted landing menu found for this role");
    return "/forbidden";
}

/**
 * The level-one menu that "/" resolves to, or null.
 *
 * SideBar uses this to suppress that menu's rail icon: the company logo above the rail
 * links to "/", so it already represents this menu, and rendering both shows two icons
 * for one destination. Sharing the walk with firstPermittedRoute() is the point - if the
 * two disagreed, the logo would lead somewhere other than the icon it replaced.
 */
export function firstPermittedTopMenuID() {
    let userDetails = null;
    try {
        userDetails = JSON.parse(localStorage.getItem("userDetails"));
    } catch (e) {
        return null;
    }
    if (!userDetails || !userDetails.menuPermission) return null;

    const landing = resolveLanding(userDetails);
    return landing ? landing.topMenuID : null;
}

/** The single walk behind both exports above. */
function resolveLanding(userDetails) {
    // Two passes: the menus that make sense to land on, then the de-prioritised ones.
    for (const skipHidden of [true, false]) {
        for (const topMenu of systemMenuList2) {
            if (!topMenu) continue;
            if (skipHidden && LANDING_DEPRIORITISED_MENU_IDS.includes(topMenu.menuID)) continue;
            if (menuPermissionLevel(userDetails, topMenu.menuID) < 1) continue;

            const link = firstPermittedLinkUnder(topMenu, userDetails);
            if (link) return {link, topMenuID: topMenu.menuID};
        }
    }
    return null;
}
